import React from 'react';
import HeroSection from '../components/HeroSection';
import FeatureSection from '../components/FeatureSection';
import ProductShowcase from '../components/ProductShowcase';
import Contact from '../pages/Contact';
import CompanyValues from '../components/CompanyValues';
import FAQ from '../components/FAQ';
// @ts-ignore: module has no declaration file
import useDynamicSEO from '../hooks/dynamicSEO';
  
const Home: React.FC = () => {
  useDynamicSEO({
    title:"Smart Parking Management & Automation App | Park Hive",
    description:"Transform parking efficiency with Park Hive — digital parking automation, real-time monitoring & revenue transparency for high-volume smart parking sites.",
    keywords:["Parking Management System","Event & Exhibition Parking Management","Parking Lot Management App","Digital Parking Solutions"," Vehicle entry exit management system","AI Parking Management Platform","Parking Lot Automation Software", "Parking revenue management app", "Tourist Attraction Parking Software", "Cinema & Multiplex Parking System"],
    ogTitle:"Smart Parking Management & Automation App | Park Hive",
    ogDescription:"Transform parking efficiency with Park Hive — digital parking automation, real-time monitoring & revenue transparency for high-volume smart parking sites."
    
  })
  return (
    <>
      <HeroSection />
      <FeatureSection />
      <ProductShowcase />
      <CompanyValues/>
      <FAQ />
      <Contact/>
      {/* <TestimonialsSection /> */}
    </>
  );
};

export default Home;